// initial state
const desktop = 1200
const state = {
  menuIsOpen: window.innerWidth > desktop
}

const mutations = {
  mutationIsOpen (state) {
    if (window.innerWidth < desktop) {
      state.menuIsOpen = !state.menuIsOpen
    }
  },
  menuIsOpenOnResize (state) {
    state.menuIsOpen = window.innerWidth > desktop
  }
}

const actions = {
  menuOnResize ({ commit }) {
    function resizeThrottler () {
      commit('menuIsOpenOnResize')
    }
    window.addEventListener('resize', resizeThrottler, false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
